/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import LinkItem from '../LinkItem';

const LinkItems = props => {
  const { theme, items, providerSet, onLogoutClick } = props;

  return (
    <>
      {items.map((item, index) => (
        <LinkItem
          key={`link-${index}`}
          theme={theme}
          item={item}
          isSocial
          providerSet={providerSet}
          onLogoutClick={onLogoutClick}
        />
      ))}
    </>
  );
};

export default LinkItems;

LinkItems.defaultProps = {
  items: [],
};

LinkItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  theme: PropTypes.shape({}),
  onLogoutClick: PropTypes.func,
  providerSet: PropTypes.bool,
};
